import {
  HumanizeDurationLanguage,
  HumanizeDuration,
} from "humanize-duration-ts"
import type { UnixTimestamp } from "./types"

export const formatNumberWithCommas = (
  number: number | string
) => new Intl.NumberFormat("en-GB").format(Number(number))

const humanizeLangService = new HumanizeDurationLanguage()
const humanizer = new HumanizeDuration(humanizeLangService)

export const formatUnixTimestamp = (
  value: UnixTimestamp
) => {
  return (
    humanizer.humanize(Date.now() - value * 1000, {
      largest: 2,
    }) + " ago"
  )
}

export const formatTimestampAsTime = (value: number) => {
  const date = new Date(value)

  return date.toLocaleTimeString()
}
